import TagManager from 'react-gtm-module';
import { PromotionPageType } from './utils';

export const TagEventName = {
  selectTag: 'select_tag',
} as const;

export interface TagTrackPromotionEventProps {
  eventName: (typeof TagEventName)[keyof typeof TagEventName];
  page: {
    path: string;
    page_type:
      | (typeof PromotionPageType)[keyof typeof PromotionPageType]
      | 'unassigned';
  };
  interaction: {
    link_text: string;
    link_url: string;
  };
}

export const trackTagEvent = ({
  eventName,
  page,
  interaction,
}: TagTrackPromotionEventProps) => {
  TagManager.dataLayer({
    dataLayer: {
      page: undefined,
      interaction: undefined,
      ecommerce: undefined,
    },
  }); // Clear ecommerce object
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      page: {
        ...page,
      },
      interaction: {
        ...interaction,
      },
    },
  });
};
